




















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { ICampaign, IFormatVersion, ICanvasBannerPlaceholder, CanvasContent, Format, Dialog } from '@models';
import FormatVersionService from '../../../services/FormatVersionService';
import CampaignService from '../../../services/CampaignService';

@Component
export default class CampaignCanvasBannerPlaceholdersForm extends Vue {
  name = 'campaign-canvas-banner-placeholder-form';

  version = 0;
  campaignService = CampaignService;
  isLoading: boolean = false;

  banners: Array<Format> = new Array();

  chosenFormats: Array<{
    id: string,
    chosenFormat: Format,
  }> = new Array();

  @Prop({ required: true, }) value: ICampaign;

  @Prop({ required: false, }) helpText?: string;

  @Prop({ type: Object as () => IFormatVersion, default: null })
  formatVersion: IFormatVersion;

  @Watch('value')
  onValueChanged() {
    this.loadFormatCanvasBannerPlaceholders();
  }

  onUpdated() {
    this.$emit('updated');
  }

  ChangeBannerDialog = new Dialog({
    formRef: 'ChangeBannerDialog',
    headline: 'Changing banner',
    message: 'If you change the banner you will lose all the changes you have done to the parameters for that placeholder on this page!',
    hasCancelBtn: true,
    hasCloseBtn: false,
    isInfoDialog: true,
    isModal: true,
    ok: () => this.changeBanner()
  });

  chosenBannerFormat: Format = null;
  chosenPlaceholder: ICanvasBannerPlaceholder = null;

  getCanvasContentIndex(id: any) {
    let index = this.value.canvasContent.findIndex(x => x.bannerPlaceholderId === id);
    return index;
  }

  get placeholders() {
    return this.formatVersion.canvasBannerPlaceholders;
  }

  chosenFormat(id: any) {
    const format = this.chosenFormats.find(x => x.id === id);
    if (format) {
      return format.chosenFormat;
    }

    return undefined;
  }

  createCanvasContent(canvasBannerPlaceholder: ICanvasBannerPlaceholder, formatVersionId: string) {
    const canvasContent = new CanvasContent({
      bannerPlaceholder: canvasBannerPlaceholder,
      bannerPlaceholderId: canvasBannerPlaceholder.id,
      campaign: this.value,
      campaignId: this.value.id,
      formatVersion: undefined,
      formatVersionId: formatVersionId,
      parameters: []
    });

    return canvasContent;
  }

  bannerSelected(value: Format, placeholder: ICanvasBannerPlaceholder) {
    this.chosenBannerFormat = value;
    this.chosenPlaceholder = placeholder;

    // If the user has already selected a value, we show a dialog to warn them about losing data.
    if (this.getCanvasContentIndex(placeholder.id) > -1) {
      this.ChangeBannerDialog.visible = true;
    } else {
      this.changeBanner()
    }
  }

  async changeBanner() {
    if (this.ChangeBannerDialog.visible) {
      this.ChangeBannerDialog.visible = false;
    }

    const existingCanvasFormat = this.value.canvasContent.find(x => x.bannerPlaceholderId === this.chosenPlaceholder.id);
    if (existingCanvasFormat) {
      this.value.canvasContent.splice(this.value.canvasContent.indexOf(this.value.canvasContent.find(x => x.bannerPlaceholderId === this.chosenPlaceholder.id)), 1);
    }

    if (this.chosenBannerFormat) {
      const oldFormat = this.chosenFormats.find(x => x.id === this.chosenPlaceholder.id);
      if (oldFormat) {
        this.chosenFormats.find(x => x.id === this.chosenPlaceholder.id).chosenFormat = this.chosenBannerFormat;
      } else {
        this.chosenFormats.push({
          id: this.chosenPlaceholder.id,
          chosenFormat: this.chosenBannerFormat
        })
      }

      const formatVersion = await this.loadLatestFormatVersion();
      const canvasContent = this.createCanvasContent(this.chosenPlaceholder, formatVersion.id);
      this.value.canvasContent.push(canvasContent);

    } else {
      this.chosenFormats.splice(this.chosenFormats.indexOf(this.chosenFormats.find(x => x.id === this.chosenPlaceholder.id)), 1);
    }
  }

  async loadLatestFormatVersion() {
    const response = await FormatVersionService.getLastFormatVersion(this.chosenBannerFormat.id);
    if (response.status == 201 || response.status == 200) {
      return response.data;
    }
  }

  loadFormatCanvasBannerPlaceholders() {
    this.value.canvasContent.forEach(canvasContent => {
      this.chosenFormats.push({ id: canvasContent.bannerPlaceholderId, chosenFormat: canvasContent.formatVersion.format });
    });
  }

  async fetchFormats(placeholderId: any, format: Format) {
    this.isLoading = true;
    var banners: Format[] = [];
    return this.campaignService.getPlaceholderFormats(placeholderId, format?.id).then(response => {
      if (response.status !== 200) {
        return [];
      }

      if (response && response.data) {
        banners = response.data;
        if (format && banners.find(x => x.id === format.id) == undefined) {
          banners.push(format);
        }

        banners.sort(
          (a, b) => {
            if (a.displayTitle.toLowerCase() < b.displayTitle.toLowerCase()) {
              return -1;
            }
            if (a.displayTitle.toLowerCase() > b.displayTitle.toLowerCase()) {
              return 1;
            }
            return 0;
          });

        this.isLoading = false;
      }

      return banners;
    });
  }

  @Watch('placeholders')
  async updateBanners() {
      var promiseAllPlaceholders = this.placeholders.map(placeholder => {
        return new Promise((resolve, reject) => {
          var bannerFetch = [];
          bannerFetch.push(this.fetchFormats(placeholder.id, this.chosenFormat(placeholder.id)));
          return Promise.all(bannerFetch).then(response => {
            return { placeholderId: placeholder.id, formats: response };
          }).then(response => {
            resolve(response);
          });

        });
      });

    Promise.all(promiseAllPlaceholders).then(res => {
      var tempBanners = [];
      res.forEach(x => {
        tempBanners[x.placeholderId] = x.formats[0];
      });
      this.banners = tempBanners;
      });
  }

  created() {
    this.loadFormatCanvasBannerPlaceholders();
    this.updateBanners();
  }
}
